import { render, staticRenderFns } from "./Postulation.vue?vue&type=template&id=4e678122&scoped=true&"
import script from "./Postulation.vue?vue&type=script&lang=js&"
export * from "./Postulation.vue?vue&type=script&lang=js&"
import style0 from "./Postulation.vue?vue&type=style&index=0&id=4e678122&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e678122",
  null
  
)

export default component.exports